import { useNavigate } from "react-router-dom";
import { Text } from "../Text/Text";
import styles from "./ArticleCard.module.scss";

export const ArticleCard = ({ href, title, src, dtString }) => {
  const navigate = useNavigate();

  const date = new Date(dtString);

  const formattedDate = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;
  const formattedTime = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;


  return (
    <div onClick={() => navigate(href)} className={styles.container}>
      <div className={styles.imgBlock}>
        <img src={src} className={styles.imgCover} alt={"Обложка статьи «" + title + "»"} />
      </div>
      <div className={styles.textBlock}>
        <div className={styles.title}>
          <Text bold color="white">
            {title}
          </Text>
        </div>
        <div className={styles.metaBlock}>
          <div className={styles.dateBlock}>
            <Text light> {formattedDate}</Text> 
            {/* <Text light> {formattedTime} </Text> */}
          </div>
        </div>
      </div>
    </div>
  );
};
